import { Navigate, Route, Routes } from 'react-router-dom';
import { Shell } from './components/Shell';
import { HomePage } from './pages/HomePage';
import { ImportPage } from './pages/ImportPage';
import { LibraryPage } from './pages/LibraryPage';
import { CaptureLibraryPage } from './pages/CaptureLibraryPage';
import { MarketItemPage } from './pages/MarketItemPage';
import { MarketSearchPage } from './pages/MarketSearchPage';
import { R2TestPage } from './pages/R2TestPage';

export function App() {
  return <Shell><Routes>
    <Route path="/" element={<HomePage/>}/>
    <Route path="/import" element={<ImportPage/>}/>
    <Route path="/library" element={<LibraryPage/>}/>
    <Route path="/library/captures" element={<CaptureLibraryPage/>}/>
    <Route path="/library/item" element={<MarketItemPage/>}/>
    <Route path="/library/search" element={<MarketSearchPage/>}/>
    <Route path="/r2-test" element={<R2TestPage/>}/>
    <Route path="*" element={<Navigate to="/" replace/>}/>
  </Routes></Shell>;
}
